import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import { commonFAQ } from '../../constants';



const gujarati = {
  introduction_heading :'લેખક બનવાના તમારા સપનાને સાકાર કરો.',
  create_novel_button_text: "તમારી પોતાની નવલકથા ની રચના લખો",
  rewards_title: <>  ઇનામ અને લાભ</>,
  rewards_para_text: <><span>ઓછા માં ઓછા 1 લાખ થી 10 લાખ સુધી ની કમાઇ કરો. </span> </>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Bonus 🖋️',
      subHeading: <>આ રીવોર્ડ દરેક સાઇન કરેલ નવલકથા ને આપવામાં આવશે જ્યારે તે લેખક પોતાની નવલકથા ઓછા માં ઓછા શબ્દો સાથે પબ્લીશ કરશે.</>,
      tableHeadings: [' ઓછામાં ઓછા શબ્દો  ', ' ઇનામ'],
      table: [
        {
          wordCount: '30,000',
          reward: '₹3000',
        },
      ],
      note: <>કોપી કરેલ અથવા સેક્સ્યુઅલ વાર્તા અમાન્ય ગણાશે.</>,
      extraNotes: [
        {
          no: 1,
          text: 'ઇનામ અથવા નફા માટે લેખકોએ Writers Benefit Programme [WBP] માટે અરજી કરવી અને કરાર પર સહી કરવી ફરજિયાત છે.',
        },
        {
          no: 2,
          text: 'પહેલા 5000 શબ્દો પૂરા કર્યા પછી પણ તમે કરાર પર સહી કરી શકો છો.',
        },
        {
          no: 3,
          text: 'સહી કર્યા પછી તમને ત્યારે ચુકવણી મળશે જો તમારું પુસ્તક અમારી ન્યૂનતમ ગુણવત્તા ધોરણોને પૂર્ણ કરે છે,તેમજ તેની રકમ આવતા મહિનાના પ્રથમ અઠવાડિયા માં મળવા પાત્ર રહેશે.          ',
        },
      ],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: 'આ પુરસ્કાર દર મહિને પ્રકાશિત ભાગ અને તેની ગુણવત્તા પર આધારિત હશે.      ',
      tableHeadings: ['શબ્દની સંખ્યા(માસિક)', 'પુરસ્કાર 💰'],
      table: [
        {
          wordCount: '30,000 થી ઓછા ',
          reward: 'કોઈ ચુકવણી નથી',
        },

        {
          wordCount: '30,000 - 50,000 ',
          reward: '₹2000',
        },
        {
          wordCount: '50,000 થી વધુ ',
          reward: '₹6000',
        },
        
      ],
      note: <>લેખક મહિનામાં વધુમાં વધુ 5 દિવસ પ્રકરણો પ્રકાશિત કરવાનું ચૂકી શકે છે.</>,
      extraNotes: [
        {
          no: 1,
          text: <>  લેખકની Writer Benefit Programme ની અરજી મંજૂર થયા પછી, આપવા પાત્ર પુરસ્કારની ગણતરી દર મહિનાની 1લી તારીખે કરવામાં આવશે.</>,
        },
        {
          no: 2,
          text: <> જેમાં પ્રાપ્ત થતા પુરસ્કાર માટે ચુકવણી દર મહિને 8મી તારીખે થશે/જો કરાર પર મહિનાની 1લી તારીખ પહેલા હસ્તાક્ષર કરવામાં આવ્યા હોય તો. </>,
        },
        {
          no: 3,
          text: <> પુરસ્કાર લેખક પ્રકાશિત કરેલ શબ્દોની સંખ્યા અને તેઓએ સંબંધિત મહિનામાં પ્રકાશિત કરેલ ભાગ કે પ્રકરણોના દિવસોની સંખ્યા પર નિર્ભર રહેશે.</>,
        },
        {
          no: 4,
          text: <> દર મહિને પ્રાપ્ત થતા પુરસ્કાર ચુકવણી ચક્ર દરમિયાન ચૂકવવામાં આવશે જે મહિનાના 1લા અઠવાડિયામાં છે જો ચુકવણી ચક્ર પહેલા કરાર પર હસ્તાક્ષર કરવામાં આવે તો.</>,
        },
      ],
    },
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'લેખક જ્યારે વાર્તા પૂર્ણ કરવાની વિનંતી કરશે ત્યારે તેને આ પુરસ્કાર આપવામાં આવશે.',
      tableHeadings: ['શબ્દની સંખ્યા(એકંદરે)', 'પુરસ્કાર'],
      table: [
        {
          wordCount: ' 2,50,000 થી ઓછા ',
          reward: 'કોઈ ચુકવણી નથી',
        },
        {
          wordCount: '2,50,000 - 3,50,000',
          reward: '₹5000',
        },
        {
          wordCount: '3,50,000 - 5,00,000',
          reward: '₹10,000',
        },
        {
          wordCount: '5,00,000 થી વધુ',
          reward: '₹25,000',
        },
      ],
      note: <>વાર્તાનો અંત સંતોષકારક હોવો જોઈએ</>,
      extraNotes: [
        {
          no: 1,
          text: <>અમારા અધિકૃત એકાઉન્ટ પર ઇમેઇલ મોકલો: writers@pocketfm.com, વિષયના શીર્ષક સાથે: પુસ્તકનું નામ, લેખકનું નામ, પૂર્ણ વાર્તાના બોનસ માટે વિનંતી.</>,
        },
        {
          no: 2,
          text: <>પુસ્તક ગુણવત્તા માપદંડની માર્ગદર્શિકાને પૂર્ણ કરે છે કે કેમ તેનું મૂલ્યાંકન કરવા માટે સંપાદકીય તપાસ પછી ચુકવણી મંજૂર કરવામાં આવશે.</>,
        },
        {
          no: 3,
          text: <>આ પુરસ્કાર માટે પાત્ર બનવા માટે, પુસ્તક Writers Benefit Programme માં સક્રિય હોવું જોઈએ.</>,
        },
      ],
    },
  ],
  deadline_content: <>   <span>પ્રોગ્રામમાં દાખલ થવાની છેલ્લી તારીખ  </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "પોકેટ નવલકથા લેખક બનો અને ઉપરોક્ત લાભ મેળવો ",
  deadline_date:31,
  deadline_date_suffix:"મી",
  days_or: " દિવસો અથવા " ,
  months_to_go:" મહિના બાકી છે!! ",
  monthInWords:"ઑક્ટો",
  month:9,
  year: 2022,
  deadline_subheading: 'એકવાર આ પ્રોગ્રામમાં જોડાયા પછી, તમે ઉપરોક્ત તમામ બોનસ માટે જીવનભર માટે પાત્ર રહેશો.',
  howItWorksArray : [
    {
      step: 'પહેલું',
      instruction:<>પ્રથમ 30,000 શબ્દો લખો અને કરાર માટે અરજી કરો✍️</>,
        stepSVG:HowItWorksStep1SVG
    },
    {
      step: 'બીજું',
      instruction:<>કરાર પર સહી કરો અને નવું સ્ટોરી બોનસ મેળવો 💸 💰</>,
        stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: 'ત્રીજું',
      instruction:<>દરરોજ પ્રકરણો અપડેટ કરો અને દર મહિને દરરોજ પ્રકાશિત કરવાનું બોનસ મેળવો 💸 💰</>,
        stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: 'ચોથું',
      instruction:<>એકવાર તમે 2,50,000 શબ્દો પૂરા કરી લો અને વાચકોની ઉત્તમ પ્રતિસાદ પછી, તમે તમારી વાર્તાને ઑડિયોબુકમાં બનાવી શકો છો. મંજૂરી પછી, પરફોર્મન્સ બોનસ પણ આપવામાં આવશે. 💰 💸 ઓછામાં ઓછા 5000 INR થી 20k INR પ્રતિ મહિને આપવામાં આવશે.</>,
        stepSVG:HowItWorksStep4SVG
  
    },
  ],
  step: "ચરણ",
  popularWritersArray : [
    {
      writerName: 'Kavita verma ના લેખક',
      novelName: 'Mein Tere Chandani',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love ના લેખક',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap ના લેખક',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  popular_writter: 'લોકપ્રિય લેખકો',


  faq: <strong>વારંવાર પૂછાતા પ્રશ્નો ?</strong>,
  frequentlyAskedQuestionsArray : commonFAQ,
  
  write_home_earn_stable_income_text :'ઘરબેઠા ફક્ત રોમાંચક વાર્તા લખી સ્થાયી કમાણી મેળવો.',
  write_home_earn_stable_income_subheading : "તો રાહ ના જુઓ, આજે લાખો વાંચકોનો સ્નેહ મેળવો અને વાર્ષિક પ્રત્યેક બુક 10 લાખ સુધી ની કમાઇ કરો.તો આજે જ લેખક ના રુપમાં તમારી નવી યાત્રા શરૂ કરો.",
  create_new_novel :"તમારી વાર્તા અહીં લખો "
 
}

// console.log(gujarati.writer_dream_text)
export default gujarati;